import React from 'react';
import { useApp } from './context/AppContext';
import { AuthPage } from './components/auth/AuthPage';
import { AppLayout } from './components/layout/AppLayout';

export function App() {
  const { isAuthenticated } = useApp();

  // If user is not authenticated, show Login page directly
  if (!isAuthenticated) {
    return <AuthPage />;
  }

  // Protected App Flow
  return <AppLayout />;
}

export default App;
